import { List, Datagrid, TextField, FunctionField, Filter, TextInput, DateField, NumberField, DateInput, NumberInput, SelectInput } from "react-admin";
import { CustomReferenceInput} from '../../../components';
import { exporter } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";
import Chip from '@material-ui/core/Chip';

const TYPE_RATE_CHOICES = [
  { id: "modulation", name: "Modulação" },
  { id: "comment", name: "Box" },
];

const MessageFilter = (props) => (
  <Filter {...props}>
    <CustomReferenceInput source="labId" label="Laboratório" reference="labs" alwaysOn/>
    <CustomReferenceInput source="project_id" label="Projeto" reference="projects"/>
    <NumberInput label="Ciclo" source="order_cycle_id" />
    <TextInput label="Documento" source="user_document" />
    <TextInput label="Nome" source="user_name" />
    <DateInput label="Avaliação De" source="rate_created_at.gte" alwaysOn/>
    <DateInput label="Avaliação Até" source="rate_created_at.lte" alwaysOn/>
    <DateInput label="Data ciclo De" source="cycle_created_at.gte" />
    <DateInput label="Data ciclo Até" source="cycle_created_at.lte" />
    <SelectInput
      label="Tipo de Comentário"
      source="type_rate_name"
      choices={TYPE_RATE_CHOICES}
      optionText="name"
      optionValue="id"
    />
  </Filter>
);

const ReviewsList = (props) => (
  <List
    bulkActionButtons={<div />}
    perPage={25}
    title="Lista de Reviews"
    exporter={exporter}
    filters={<MessageFilter />}
    sort={{ field: "rate_created_at", order: "DESC" }}
    pagination={<ListPagination />}
    actions={<CustomActions />}
    {...props}
  >
      <Datagrid rowClick="edit">
      <TextField label="Laboratório" source="lab_name" sortable={false} />
      <TextField label="Projeto" source="project_name" sortable={false} />
      <TextField label="Ciclo" source="order_cycle_id" />
      <DateField label="Data de criação do ciclo" source="cycle_created_at" options={{ year: 'numeric', month: '2-digit', day: '2-digit' }} />
      <TextField label="Documento" source="user_document" />
      <TextField label="Nome" source="user_name" />
      <FunctionField label="Especialidades" render={record => (
        record.user_specialties
          .filter(specialty => specialty)
          .map(specialty => <Chip key={specialty} label={specialty} style={{ margin: 2 }} />)
      )} />
      <NumberField label="Nota" source="order_rate" />
      <TextField label="Comentário" source="rate_value" />
      <DateField label="Data da avaliação" source="rate_created_at" options={{ year: 'numeric', month: '2-digit', day: '2-digit' }} />
      <TextField label="Amostra" source="sample_name" sortable={false} />
    </Datagrid>
  </List>
);

export default ReviewsList;
